/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsDimensions interface.
 */
export function instanceOfFxIdDomainSettingsDimensions(value) {
    if (!('Width' in value) || value['Width'] === undefined)
        return false;
    if (!('Height' in value) || value['Height'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsDimensionsFromJSON(json) {
    return FxIdDomainSettingsDimensionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsDimensionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Width': json['Width'],
        'Height': json['Height'],
    };
}
export function FxIdDomainSettingsDimensionsToJSON(json) {
    return FxIdDomainSettingsDimensionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsDimensionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Width': value['Width'],
        'Height': value['Height'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsDimensions.js.map